// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// In a real app, use environment variables for these values
const firebaseConfig = {
  apiKey: "AIzaSyDVkBv2v_2AOvu85ne8BhAq-P4pC-jyfx4",
  authDomain: "zonexvendor.firebaseapp.com",
  projectId: "zonexvendor",
  storageBucket: "zonexvendor.firebasestorage.app",
  messagingSenderId: "637661039653",
  appId: "1:637661039653:web:c39bb762a846aa123883cc",
  measurementId: "G-XS5SMKW7WL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
export default app;